import { Box, Card, makeStyles, Paper, Typography } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up('sm')]: {
      margin: theme.spacing(5),
      padding: theme.spacing(3),
    },
    [theme.breakpoints.down('xs')]: {
      marginTop: theme.spacing(5),
      marginBottom: theme.spacing(5),
      padding: theme.spacing(2),
    },
  },
  pageHeader: {
    display: 'flex',
  },
  pageIconBox: {
    alignContent: 'center',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
  pageIcon: {
    display: 'inline-block',
    padding: theme.spacing(2),
    color: '#3c44b1',
  },
  pageTitle: {
    paddingLeft: theme.spacing(4),
    '& .MuiTypography-subtitle2': {
      opacity: '0.6',
    },
  },
}));

export default function PageHeader(props) {
  const classes = useStyles();
  const { title, subTitle, icon } = props;
  return (
    <Paper elevation={1} square className={classes.root}>
      <Box className={classes.pageHeader}>
        <Box className={classes.pageIconBox}>
          <Card className={classes.pageIcon}>{icon}</Card>
        </Box>
        <Box className={classes.pageTitle}>
          <Typography variant="h6">{title}</Typography>
          <Typography variant="subtitle2">{subTitle}</Typography>
        </Box>
      </Box>
    </Paper>
  );
}
